document.addEventListener("DOMContentLoaded", () => {
  $("#salary-month").select2();
  $("#salary_month_drop").datetimepicker({
    format: window.MONTH_YEAR_FORMAT,
    viewMode: "months",
    maxDate: moment($("#salary_month_drop").data("max-month")),
    icons: {
      previous: "fas fa-chevron-left",
      next: "fas fa-chevron-right",
    },
  });
  const consolidatedSalaryBreakdownMonthFields = $(".consolidated-salary-breakdown-month");
  if (consolidatedSalaryBreakdownMonthFields.length) {
    consolidatedSalaryBreakdownMonthFields.datetimepicker({
      format: window.MONTH_YEAR_FORMAT,
      viewMode: "months",
      useCurrent: false,
      minDate: moment(consolidatedSalaryBreakdownMonthFields.first().data("min-month")),
      maxDate: moment(consolidatedSalaryBreakdownMonthFields.first().data("max-month")),
      icons: {
        previous: "fas fa-chevron-left",
        next: "fas fa-chevron-right",
      },
    });
  }

  $("#salary-logs-table").DataTable({
    ...persistedSearchState("salary-logs-search"),
    fixedHeader: true,
    processing: true,
    serverSide: true,
    scrollX: true,
    ajax: {
      type: "get",
      url: "/employee_salaries",
      dataType: "json",
      data: (data) => {
        data.page =
          parseInt($("#salary-logs-table").DataTable().page.info().page) + 1;
        data.per_page = $("#salary-logs-table").DataTable().page.info().length;
        data.search = {
          text: data.search.value,
          currency: $("#select-currency-filter").val(),
          convert_to: $("#select-convert-to-currency").val(),
          user_type: $("#select-user-type-filter").val(),
        };
        data.order = $("#salary-logs-table").DataTable().order()[0][0];
        data.direction = $("#salary-logs-table").DataTable().order()[0][1];
      },
    },
    drawCallback: () => {
      if ($("#salary-logs-table").DataTable().rows().count()) {
        $("#salary-logs-table tr:last").attr("id", "net-total-row");
      }
    },
    deferRender: true,
    columnDefs: [
      {
        targets: 1,
        createdCell: (td, cellData, rowData, row, col) => {
          if (rowData[20]) {
            $(td).closest("tr").addClass("cursor-pointer");
            $(td).closest("tr").attr("id", "payroll-sheet-row");
            $(td).closest("tr").attr("data", rowData[20].salary_log_id);
            $(td).closest("tr").addClass(rowData[20].row_color_code);
            $(td).addClass("employee-profile-page text-break");
            $(td).attr(
              "onClick",
              `window.open('/employees/${rowData[20].employee_external_id}', '_blank')`
            );
          }
        },
      },
      {
        targets: 18,
        createdCell: (td, cellData, rowData, row, col) => {
          if (rowData[20] && rowData[20].salary_partially_held === true) {
            $(td).addClass("bg-light-red");
          }
        },
      },
      {
        targets: 16,
        createdCell: (td, cellData, rowData, row, col) => {
          $(td).addClass("text-nowrap disable-propagation");
        },
      },
    ],
  });
  debounceSearch("#salary-logs-table");
  searchFilterBadge("#salary-logs-table");
});

$(document).on(
  "change",
  "#salary-month, #select-currency-filter, #select-convert-to-currency, #select-user-type-filter",
  () => {
    if (window.location.pathname.split("/")[1] == "employee_salaries") {
      $.ajax({
        type: "GET",
        url: "/employee_salaries",
        dataType: "script",
        data: {
          salary_month: $("#salary-month").find("option:selected").text(),
        },
      });
    }
  }
);

$(document).on("change", "#salary_logs_csv", (e) => {
  const fileName = $(e.target).val().split("\\").pop();
  if (fileName.replace(/^.*\./, "") === "csv") {
    $(e.target)
      .siblings(".custom-file-label")
      .addClass("selected")
      .html(fileName);
    $(e.target).parent().find("p").remove();
    $("#import-salary-logs-btn").attr("disabled", false);
  } else {
    $("#import-salary-logs-btn").attr("disabled", true);
    $(e.target)
      .parent()
      .append("<p id='error' style='color: red'>Please choose csv file.</p>");
    setTimeout(() => {
      $("#import-salary-logs-btn").attr("disabled", true);
      $("#error").remove();
    }, 5000);
    e.preventDefault();
  }
});
